window.shares = function (types, pt_img, url) {
    if (!pt_img) pt_img = "";
    if (url == "" || url == undefined || url == "undefined") {
        url = location.href; //window.location.hostname;
    }
    switch (types) {
        case "fb":
            window.open(
                "http://www.facebook.com/share.php?u=".concat(
                    encodeURIComponent(url)
                )
            );
            break;
        case "tr":
            window.open(
                "https://twitter.com/intent/tweet?original_referer=" +
                    encodeURIComponent(url) +
                    "&url=" +
                    encodeURIComponent(url)
            );
            // window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(document.title)) .concat('') .concat(encodeURIComponent(url)))
            break;
        case "gp":
            window.open(
                "http://plus.google.com/share?url=".concat(
                    encodeURIComponent(url)
                )
            );
            break;
        case "sn":
            window.open(
                "http://v.t.sina.com.cn/share/share.php?url=" +
                    encodeURIComponent(url) +
                    "&title=" +
                    encodeURIComponent(document.title)
            );
            break;
        case "pt":
            window.open(
                "http://pinterest.com/pin/create/like/?url=" +
                    encodeURIComponent(url) +
                    "&media=" +
                    encodeURIComponent(pt_img) +
                    "&description=" +
                    encodeURIComponent(document.title)
            );
            break;
        case "line":
            //http://line.naver.jp/R/msg/text/?{msg}
            //msg = 在LINE裡面顯示的內容
            //僅限行動裝置
            window.open(
                "https://social-plugins.line.me/lineit/share?url=" +
                    encodeURIComponent(url)
            );
            break;
    }
    return false;
};

window.gotoURL = function (url, type) {
    if (type == "open") {
        window.open(url);
    } else {
        window.location.href = url;
    }
};

// 鎖捲軸
// 例: 如果要鎖 body:
// var body = $('body');
// lockScroll(body);
window.lockScroll = function (target) {
    var scroll_top = $(window).scrollTop();
    var lock_count = $(target).data("lock_count");

    if (typeof lock_count === "undefined" || lock_count === 0) {
        $(target).data("lock_count", 1);

        target.data("scroll_style", target.attr("style"));
        target.data("scroll_top", scroll_top);
        target.css({
            overflow: "hidden",
            position: "fixed",
            top: scroll_top * -1 + "px",
        });
    } else {
        $(target).data("lock_count", lock_count + 1);
    } // end of if
}; // end of function

// 開捲軸 - 如果鎖了3次, 需要呼叫此　function 3 次後才會解鎖
//
// target　要解開鎖的目標
// unlock_all 強制解鎖, 無視鎖被加了幾次
window.unlockScroll = function (target, unlock_all) {
    var lock_count = $(target).data("lock_count");

    if (typeof lock_count === "undefined" || lock_count === 0) {
        lock_count = 0;
        $(target).data("lock_count", 0);
    } else {
        lock_count = lock_count - 1;
        $(target).data("lock_count", lock_count);
    } // end of if

    if (
        lock_count === 0 ||
        (typeof unlock_all !== "undefined" && unlock_all === true)
    ) {
        var scroll_top = target.data("scroll_top");
        var scroll_style = target.data("scroll_style");

        if (scroll_style) {
            target.attr("style", scroll_style);
        } else {
            target.removeAttr("style");
        }

        $(window).scrollTop(scroll_top);
    } // end of if
}; // end of function

/**
 *
 * @returns {boolean}
 */
window.confirmData = function (form) {
    $("#rd_confirm_data_div_text").text(
        "Please confirm the information is correct ?"
    );
    $("#rd_confirm_data_div").addClass("show");

    $("#rd_confirm_data_div_confirm").on("click", function () {
        form.submit();
        $("#rd_confirm_data_div_confirm").off();
    });
};

window.submitData = function (form) {
    form.submit();
};

$(function () {
    $("#rd_confirm_data_div_cancel").on("click", function () {
        $("#rd_confirm_data_div").removeClass("show");
    });
});

window.showLoadingDialog = function () {};

window.hideLoadingDialog = function () {};
